export enum InvestorType {
  PF = "PF",
  PJ = "PJ",
  Investment = "FUNDO_INVESTIMENTO",
  Entity = "ENTIDADE",
}

export enum UserType {
  InvestmentPf = "INVESTIDORPF",
  InvestmentPj = "INVESTIDORPJ",
  Investment = "INVESTIDOR",
  InvestmentFund = "INVESTIDORFI",
  Entity = "ENTIDADE",
  Undefined = "INDEFINIDO",
}
